// Mirrors the backend Core.Entities.Enum.RequestItem.RequestItemPermissions.
// No CAN_EDIT_ITEM_PACKETS — item packets are a compliance-only concept and do not apply to requests.
export enum RequestItemPermissions {
    CAN_VIEW_ITEM = 1,
    CAN_REQUEST_ACCESS = 2,
    CAN_MANAGE_ITEM = 10,
    CAN_EDIT_ITEM = 100,
    CAN_TOGGLE_PRIVACY = 200
}
